module.exports = __webpack_public_path__ + "img/undraw_book_lover_mkck.ec09339d.svg";